import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NotificationComponent } from '@tdwb/core';
import { AgreementsBase } from '../agreements.base';

@Component({
  selector: 'td-wb-old-amex-nyse',
  templateUrl: './old-amex-nyse.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [NgTemplateOutlet, NotificationComponent]
})
export class OldAmexNyseComponent extends AgreementsBase {
  constructor() { super(); }
}
